import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import TipoDoc1 from '../imagens/CadTipoDoc/TipoDoc1.png';
import TipoDoc2 from '../imagens/CadTipoDoc/TipoDoc2.png';
import TipoDoc3 from '../imagens/CadTipoDoc/TipoDoc3.png';
import TipoDoc4 from '../imagens/CadTipoDoc/TipoDoc4.png';
import TipoDoc5 from '../imagens/CadTipoDoc/TipoDoc5.png';
import TipoDoc6 from '../imagens/CadTipoDoc/TipoDoc6.png';

export default class CadTiposDoc extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Cadastro de Tipos de Documento"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Cadastro de Tipos de Documento:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={TipoDoc1} alt="Tipo 1"/>
                        </div>

                        <div className="gray_bar"></div>  

                        <div className="image-wrapper">
                            <img src={TipoDoc2} alt="Tipo 2"/>
                        </div>                                            

                        <h3>No cadastro de Tipos de Documentos nós temos:</h3>
                        <ol>
                            <li>Cadastrar um novo Tipo de Documento.</li>
                            <li>Filtro para busca de um Tipo de Documento usando a descrição.</li>
                            <li>Tabela exibindo os Tipo de Documento que foram cadastradas até agora.</li>
                            <li>Botões auxiliares para trocar a situação.</li>
                            <li>Botões auxiliares para alterar/excluir o Tipo de Documento.</li>
                            <li>Paginação da tabela de Tipos de Documentos.</li>
                        </ol>

                        <div className="gray_bar"></div>            

                        <h3>Como cadastrar um novo Tipo de Documento</h3>

                        <p>
                            Para cadastrar um novo Tipo de Documento primeiro clique no botão "Adicionar" para começar o cadastro. 
                        </p>     
                        <p>
                            Na tela de cadastro, basta preencher os dados corretamente e clicar no botão "Salvar".
                        </p>   

                        <div className="image-wrapper">
                            <img src={TipoDoc3} alt="Tipo 3"/>
                        </div>
                        <div className="image-wrapper">
                            <img src={TipoDoc4} alt="Tipo 4"/>
                        </div>                        

                        <p>
                            Um detalhe desse cadastro é o vinculo entre o tipo de documento e a conta corrente. Quando o gestor realiza o controle de caixa, ele 
                            deve considerar a qual conta corrente cada tipo de documento será atribuído, para determinar para onde o valor do lançamento é atribuído. 
                         </p> 
                         <p>
                            Um exemplo é quando o tipo de documento é Dinheiro, então o gestor precisa definir a qual conta corrente deve ser depositado o valor do 
                            pagamento em dinheiro.                        
                         </p>

                        <div className="image-wrapper">
                            <img src={TipoDoc5} alt="Tipo 5"/>
                        </div>     

                        <div className="gray_bar"></div>    

                        <h3>Como Alterar/Excluir um Tipo de Documento</h3>  

                        <p>
                            Para alterar a situação de um Tipo de Documento entre ativo ou inativo, basta utilizar os botões da coluna Situação na tabela de Tipos de Documentos.
                            Para alterar outros dados, utilize o botão com o lápis na última coluna da tabela para acessar a tela de alteração. 
                        </p>    
                        <p>
                            Para excluir um Tipo de Documento basta clicar no botão com o icone da lixeria na última coluna da tabela mostrando todos os Tipos de Documentos.
                            Lembresse que se um Tipo de Documento ja foi usado para fazer um lançamento financeiro então ele não pode ser exluído.
                        </p>   
                        <div className="image-wrapper">
                            <img src={TipoDoc6} alt="Tipo 6"/>
                        </div>                                                                                               
    
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadTiposDoc.js